import { t } from "../../i18n";
import { useEffect } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useProjectStore } from "../../state/projectStore";
import { switchFromUrl } from "../../state/unsavedGuard";
import { loadAnyProject } from "../../storage";
import { useAuth } from "../../auth/useAuth";
import { CadShell } from "../cad/CadShell";
import { ModelLayout } from "../cad/ModelLayout";
import { QuantitiesLayout } from "../cad/QuantitiesLayout";
import { SmartDesignLayout } from "../design/SmartDesignLayout";
import { DrawingLayout } from "../sheet/DrawingLayout";
import { useCadUi } from "../../state/cadUiStore";
import { ConflictDialog } from "./ConflictDialog";

export function ProjectPage(): JSX.Element {
  const { id } = useParams();
  const nav = useNavigate();
  const { project, openProject, origin, openedAt, tabLock } = useProjectStore();
  const { status, subscription } = useAuth();
  const layout = useCadUi((s) => s.layout);
  useEffect(() => {
    if (project?.id === id || status === "unknown" || status === "guest") return;
    const load = (): void => void loadAnyProject(id ?? "", status === "authed").then((r) => { if (r) openProject(r.project, r.origin); else nav("/"); });
    // Başka proje açıkken (geri/ileri ya da elle adres) önce değişiklik sorulur; İptal → adres açık projeye döner
    const cur = project?.id;
    if (cur) switchFromUrl(load, () => nav(`/proje/${cur}`, { replace: true })); else load();
  }, [id, project?.id, openProject, nav, status]);
  // Abonelik yazmaya kapalıysa bulut projesi salt okunur (sunucu da 402 döner); başka sekme düzenliyorsa da (tabLock)
  useEffect(() => {
    if (origin === "cloud" && subscription) useProjectStore.setState({ readOnly: !subscription.canWrite || tabLock !== null });
  }, [origin, subscription, openedAt, tabLock]);
  // API'li sürümde uygulama yalnız üyelere (misafir → giriş); API'siz statik sürüm yerel çalışmaya devam eder
  if (status === "guest") return <Navigate to="/giris" replace />;
  if (!project) return <p className="p-6 text-stone">{t("Yükleniyor…")}</p>;
  return (
    <CadShell current="project">
      {layout === "quantities" ? <QuantitiesLayout /> : layout === "design" ? <SmartDesignLayout /> : layout === "drawing" ? <DrawingLayout /> : <ModelLayout />}
      <ConflictDialog />
    </CadShell>
  );
}
